import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ErrorsModule } from './exceptions/errors.module';

import { DateValueAccessorDirective } from './date-value-accessor';

@NgModule({
    imports: [CommonModule, ErrorsModule],
    declarations: [DateValueAccessorDirective],
    exports: [ErrorsModule, DateValueAccessorDirective],
})
export class SeUiUtilitiesModule {}
